/* The "Vendors Account Number" block on a member's view page is driven by the
   vendorProfile API - one row per vendor, keyed by apiName. Those same vendors
   can be turned into member-list columns, so the admin's column configuration
   and the vendor portal's table need one shared way of naming them.

   A column field is the apiName behind a prefix ("vendorAccount:Coke_Account_Number")
   so it never collides with a real member field, and the value for a row
   arrives from the API under that very same key. */
export const VENDOR_ACCOUNT_FIELD_PREFIX = "vendorAccount:";

export const vendorAccountField = (apiName) =>
  `${VENDOR_ACCOUNT_FIELD_PREFIX}${apiName}`;

/* the apiName back out of a column field, or null when the field is a plain
   member column */
export const vendorAccountApiName = (field) =>
  typeof field === "string" && field.startsWith(VENDOR_ACCOUNT_FIELD_PREFIX)
    ? field.slice(VENDOR_ACCOUNT_FIELD_PREFIX.length)
    : null;

/* read the way the member view reads it: "Coke_Account_Number" -> "Coke Account Number" */
export const vendorAccountLabel = (apiName) =>
  String(apiName || "")
    .replace(/_/g, " ")
    .replace(/[\s.]+$/, "")
    .trim();

/* The vendors the member view actually renders, in the order it renders them.
   vendorProfile can hold more rows than that, and the view shows only the ones
   named here - the column configuration has to offer exactly the same set. */
export const VENDOR_ACCOUNT_ORDER = [
  "Biolyte_Account_Number",
  "BTC_Account_Number",
  "Buffalo_Rock_Account_Number",
  "Coke_Account_Number",
  "Community_Coffee_Account_Number",
  "Core_Mark_Account_Number",
  "Eternal_Water_Account_Number",
  "Fiji_Water_Account_Number",
  "Imperial_Account_Number",
  "J_R_Account_Number",
  "Keurig_Dr_Pepper_Account_Number",
  "Krispy_Krunchy_Chicken_Account_Number",
  "Light_on_A_Hill_Account_Number",
  "Lynco_Account_Numbers",
  "McLane_Co_Account_Number",
  "Monster_Account_Number",
  "MostEdge_Account_Number",
  "PepsiCo_Account_Number",
  "RapidXchange_Account_Number",
  "Red_Bull_Account_Number",
  "redbull ....",
  "Stewart_Account_Number",
  "United_Distributors_Account_Number",
  "Utz_Golden_Flake_Account_Number",
];

/* the same vendors the member view lists, as selectable columns */
export const vendorAccountColumns = (vendorProfile) =>
  VENDOR_ACCOUNT_ORDER.filter((apiName) =>
    (vendorProfile || []).some((vendor) => vendor?.apiName === apiName)
  ).map((apiName) => ({
    label: vendorAccountLabel(apiName),
    field: vendorAccountField(apiName),
    className: "member-vendor_account",
  }));
